import { render, staticRenderFns } from "./UgcModal.vue?vue&type=template&id=d0154bbe"
import script from "./UgcModal.vue?vue&type=script&lang=js"
export * from "./UgcModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports